import React, { useRef } from 'react';
import QuickSearchNavigation from '@fiverr-private/quick_search_navigation';
import { user, rollouts } from '../../PropTypes';
import withContext from '../../lib/withContext';
import Nav from '../../lib/Nav';
import If from '../../lib/If';
import Layout from '../../components/Layout';
import { LogoSeller } from '../../components/Logo';
import MainRow from '../../components/MainRow';
import SubMenus from '../../components/Seller/SubMenus';
import SellerNotifications from '../../components/Seller/SellerNotifications';
import SellerInbox from '../../components/Seller/SellerInbox';
import Navicon from '../../components/Navicon';
import { SellerDashboardLink } from '../../components/SellerLinks';
import UserBalanceTag from '../../components/UserBalanceTag';
import SellerQuickSearchLink from '../../components/Seller/SellerQuickSearchLink';
import TeamDashboardMenu from '../TeamAccountMember/TeamDashboardMenu';
import LazyFiverrEmbedSellerStatus from '../../components/Seller/FiverrEmbedSellerStatus/LazyFiverrEmbedSellerStatus';

import './style.scss';

export const Seller = (_props, { rollouts, user }) => {
    const quickSearchRef = useRef();
    const displayQuickSearch = rollouts.inSellerQuickSearchRollout;

    return (
        <Layout className="seller-layout">
            <If condition={displayQuickSearch}>
                <QuickSearchNavigation innerRef={quickSearchRef} />
            </If>
            <MainRow>
                <Navicon className="nav-opener-height-align" />
                <LogoSeller username={user.username} />
                <Nav className="seller-nav-left">
                    <Nav.Item displayFromLG>
                        {user.teamAccount ? (
                            <TeamDashboardMenu />
                        ) : (
                            <SellerDashboardLink
                                sellerId={user.id}
                                sellerUsername={user.username}
                                className="seller-main-item"
                            />
                        )}
                    </Nav.Item>
                    <Nav.Item displayFromLG>
                        <SubMenus.MyBusiness />
                    </Nav.Item>
                    <Nav.Item displayFromLG>
                        <SubMenus.GrowthAndMarketing />
                    </Nav.Item>
                    <Nav.Item displayFromLG>
                        <SubMenus.Analytics />
                    </Nav.Item>
                </Nav>
                <Nav alignToRight className="seller-nav-right">
                    <Nav.Item displayFromSM className="pad-less">
                        <LazyFiverrEmbedSellerStatus />
                    </Nav.Item>
                    <If condition={displayQuickSearch}>
                        <Nav.Item displayFromSM className="pad-less">
                            <SellerQuickSearchLink
                                onClick={() => {
                                    quickSearchRef.current && quickSearchRef.current.open();
                                }}
                            />
                        </Nav.Item>
                    </If>
                    <Nav.Item displayFromSM className="pad-less">
                        <SellerNotifications username={user.username} />
                    </Nav.Item>
                    <Nav.Item displayFromSM className="pad-less">
                        <SellerInbox username={user.username} />
                    </Nav.Item>
                    <Nav.Item displayFromSM className="pad-16">
                        <SubMenus.HelpAndResources />
                    </Nav.Item>
                    <Nav.Item displayFromSM className="pad-less">
                        <SubMenus.Avatar />
                    </Nav.Item>
                    <If condition={user.balance}>
                        <Nav.Item displayFromSM className="pad-left-for-avatar">
                            <UserBalanceTag onSellerNav balance={user.balance} isSeller username={user.username} />
                        </Nav.Item>
                    </If>
                </Nav>
            </MainRow>
        </Layout>
    );
};

Seller.contextTypes = {
    user,
    rollouts,
};

/**
 * @param {HeaderProps} props
 * @returns {React.ReactElement} Header
 */
export default withContext(Seller);
